import React, { Component, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link,Badge,Checkbox, Select,MenuItem,ListItemText, InputLabel, Box, FormControl,OutlinedInput, Container, Grid, Card, CardContent, CardHeader, Divider, Typography, Icon, LinearProgress, linearProgressClasses, CardActions, Button, Chip, CircularProgress, TextField , Radio, Dialog, DialogTitle, CardActionArea} from '@mui/material';
import AddShoppingCart from '@mui/icons-material/AddShoppingCart'
import { Modal } from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import * as _ from 'lodash'
import FormLabel from '@mui/material/FormLabel'
import { _freedomAxios,_axios } from 'src/plugins/axios';
import { Notify } from 'src/components/common/Notify';
import  JsonRulesConfig  from 'src/models/jsonRules';

export default function PackageProperty () {
    const [entityRealtionId, setEntityRelationId] = React.useState(0);
    const [packageForERId, setPackageForERId] = React.useState([]);
    const [pacakgeProperty, setPackageProperty] = React.useState([]);
    const [erIdStatus, setErIdStatus] = React.useState('');
    // const res = [
    //     {
    //         "PERP_Id": 71851183,
    //         "PERP_PER_Id": 17520408,
    //         "PERP_PropertyName": "HealthCheckStartDate",
    //         "PERP_PropertyValue": "2022-01-01",
    //         "PERP_IsActive": true,
    //         "PERP_CreatedBy": 584600,
    //         "PERP_CreatedOn": "2022-02-22T12:12:24.233Z",
    //         "PERP_ModifiedBy": 584600,
    //         "PERP_ModifiedOn": "2022-02-22T12:12:24.233Z",
    //         "PERP_PropertyType": 9722
    //     },
    //     {
    //         "PERP_Id": 71851184,
    //         "PERP_PER_Id": 17520408,
    //         "PERP_PropertyName": "HealthCheckEndDate",
    //         "PERP_PropertyValue": "2023-02-01",
    //         "PERP_IsActive": true,
    //         "PERP_CreatedBy": 584600,
    //         "PERP_CreatedOn": "2022-02-22T12:12:24.233Z",
    //         "PERP_ModifiedBy": 584600,
    //         "PERP_ModifiedOn": "2022-02-22T12:12:24.233Z",
    //         "PERP_PropertyType": 9722
    //     },
    //     {
    //         "PERP_Id": 71851185,
    //         "PERP_PER_Id": 17520408,
    //         "PERP_PropertyName": "JsonRule",
    //         "PERP_PropertyValue": "{\"name\":\"17520407\",\"decisions\":[{\"conditions\":{\"all\":[{\"fact\":\"Appointments\",\"operator\":\"equal\",\"value\":0},{\"fact\":\"RelationId\",\"operator\":\"equal\",\"value\":1},{\"fact\":\"EmployeeAge\",\"operator\":\"lessThan\",\"value\":\"35\"}]},\"event\":{\"type\":\"Sponsored\",\"params\":{}}},{\"conditions\":{\"any\":[{\"fact\":\"BenefAge\",\"operator\":\"lessThan\",\"value\":\"35\"}]},\"event\":{\"type\":\"Not Applicable\",\"params\":{}}},{\"conditions\":{\"all\":[{\"fact\":\"BenefAge\",\"operator\":\"greaterThanInclusive\",\"value\":\"35\"},{\"all\":[{\"fact\":\"RelationId\",\"operator\":\"equal\",\"value\":1},{\"fact\":\"Appointments\",\"operator\":\"notEqual\",\"value\":0}]}]},\"event\":{\"type\":\"Paid\",\"params\":{}}}],\"attributes\":[{\"name\":\"EmployeeAge\",\"type\":\"number\"},{\"name\":\"EmployeeGrade\",\"type\":\"string\"},{\"name\":\"BenefGrade\",\"type\":\"string\"},{\"name\":\"BenefAge\",\"type\":\"number\"},{\"name\":\"Gender\",\"type\":\"string\"},{\"name\":\"Appointments\",\"type\":\"number\"},{\"name\":\"RelationId\",\"type\":\"number\"}]}",
    //         "PERP_IsActive": true,
    //         "PERP_CreatedBy": 584600,
    //         "PERP_CreatedOn": "2022-02-22T12:12:24.233Z",
    //         "PERP_ModifiedBy": 584600,
    //         "PERP_ModifiedOn": "2022-02-22T12:12:24.233Z",
    //         "PERP_PropertyType": 9722
    //     }
    // ];
    const showDatePickerFor = ['HealthCheckStartDate', 'HealthCheckEndDate'];
    let entityFromSession= sessionStorage.getItem('entityId');
   
    const [entityId, setEntityId] = React.useState(entityFromSession);
    const [entityRelationList,setEntityRelationList] = React.useState([]);
    const [entityType, setEntityType] = React.useState('');
    const [startDate,setStartDate] = React.useState(new Date().toISOString());
    const [ endDate,setEndDate] = React.useState(new Date().toISOString());
    const [pacakgePropertyClick, setPacakgePropertyClick] = React.useState(false);
    const JSONRules = [
    //     'Sponsored For Employee For A Particular Gender',
    //     'Sponsored For Employee For A Particular Age',
    //     'Sponsored For Employee For A Particular Age And Gender',
    //     'Sponsored For Employee For A Particular Grade',
    //     'Sponsored For Employee For A Particular Gender And Grade',
    //     'Sponsored For Employee For A Particular Age, Gender And Grade',
    //     'Sponsored For Employee And Spouse For A Particulat Grade And Gender',
    //     'Sponsored For Employee And Beneficiaries Are Sponsored Once',
    //     'Sponsored For Employee And Beneficaires Are Sponsored For A Particular Gender',
    //     'Emp-Sponsored-Grade-Benf-Once-Sponsored-Gender',
    //     'Sponsored For Employee Only',
    //     'Emp-Sponsored-Benf-Once-Sponsored-Gender'
    ]
    const [ jsonRuleSelector, setJsonRuleSelector ] = React.useState('');
    const [ jsonRulesShower, setJsonRuleShower ] = React.useState({});
    const [ age, setAge ] = React.useState(0);
    const [gender, setGender] = React.useState('');
    const [grade, setGrade ] = React.useState('');
    const [operator, setOperator] = React.useState('');
    const showProperties  = ['HealthCheckStartDate', 'HealthCheckEndDate', 'JsonRule']; 
    let remainingProp = [];
    let ERId = sessionStorage.getItem('EntityRelationId');

    const setDate = (pos, value) => {
        if(pos == 'start')
            setStartDate(value)
        else{
            setEndDate(value)
        }
    }

    const showDate = (date) => {
        if(date =='start')
            return startDate
        else
            return endDate
    }

    const GenderPicker = () => (
        <Select sx={{ m: 1, minWidth: 120 }} 
                        required = {true}
                        value={gender}
                        onChange={(ev) => { setGender(ev.target.value) }}
                        renderValue={(selected) => selected}
                        label="Gender"
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        >
                            { ['M','F'].map((val,index) => (
                               <MenuItem sx={{ py: 0 }} value={val} key={index}>
                                    <ListItemText primary={val} />
                                </MenuItem>
                           ))}

        </Select>
    )

    const AgePicker = () => (
        <div>
                                <TextField number = "true" sx={{ m: 2, minWidth: 120 }} id="outlined-basic" label="Age" variant="outlined" type="number"/> 
                                <Select sx = {{ m: 1, minWidth: 120 }} 
                                required = {true}
                                value={operator}
                        onChange={(ev) => { setOperator(ev.target.value) }}
                        renderValue={(selected) => selected}
                        label="Operator"
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper">
                                    {['greaterThanInclusive', 'greateThan','lessThan', 'lessThanInclusive'].map((val,index) =>(
                                        <MenuItem sx={{ py: 0 }} value={val} key={index}>
                                           <ListItemText primary={val} />
                                       </MenuItem> 
                                    ))}
                                </Select>
        </div>
    )

    const GradeSelector = () => (
        <TextField
        sx={{ m: 2, minWidth: 120 }}
        id="outlined-name"
        label="Grade"
        value={grade}
        onChange={(e) => setGrade(e.target.value)}
        />
    )

    const jsonRulesConfigSetter = (rule) => {
        let ruleSetter = JsonRulesConfig.find((obj) => obj.rule == rule);
        setJsonRuleShower(ruleSetter);
    }


    const JsonRuleEditor = () => {
        return (
            <Card>
                <CardContent>
                        <Select sx={{ m: 1, minWidth: 120 }}
                         required = {true}
                        value={jsonRuleSelector}
                        onChange={(ev) => { console.log(ev.target.value);  setJsonRuleSelector(ev.target.value); jsonRulesConfigSetter(ev.target.value) }}
                        renderValue={(selected) => selected}
                        label="Rule"
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        >
                           {/* { JSONRules.map((val,index) => (
                               <MenuItem sx={{ py: 0 }} value={val} key={index}>
                                    <ListItemText primary={val} />
                                </MenuItem>
                           ))} */}
                           {JsonRulesConfig.map((val, index) => (
                               <MenuItem sx={{ py: 0 }} value={val.rule} key={index}>
                                    <ListItemText primary={val.rule} />
                                </MenuItem>
                           ))}
                        </Select>
                </CardContent>
                {jsonRulesShower.age ? (
                        <AgePicker />
                        ): <></>}
                {jsonRulesShower.gender ? (
                <GenderPicker /> ) : <></>}
                {jsonRulesShower.grade ? (
                        <GradeSelector /> 
                ) : <></>}
            </Card>
        )
    }

    const DatePickerComponent = (pos) => {
        {console.log(  "DatePcikerCompnenet" ,pos.pos)}

        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker sx = {{margin : '1%', width: '30%'}}
                    label="Date"
                    inputFormat="MM/dd/yyyy"
                    value={showDate(pos.pos)}
                    onChange={(e) => setDate(pos.pos,e)}
                    formatDate = {(date) => moment(date).format('MM-DD-YYYY')}
                    renderInput={(params) => <TextField {...params} />}
                />
            </LocalizationProvider> 
        );
    } ;

    const pacakgeForERId = (packId, erid) => {
        let payLoad = {
            "ER_Id" : erid,"packageId":packId
       };
        _freedomAxios
        .post('corporate/packageInfoForER_Id', payLoad)
        .then((response) => {
            if(response.data.isSuccess){
                let res = response.data.result;
                setPackageForERId(res);
            }
        })
        .catch((error) => {

        });
    }

    const packagePropertyCreation = (packId, remainingProp) => {
        console.log(  "reached" ,packId,remainingProp);
        let payLoad = {}
        let packageProp = remainingProp && remainingProp.reduce((final, name) => {
            console.log("reamainaingProp"  ,final, name);
            if(name == 'JsonRule'){
                return ({ ...final, [name] : {
                    "validOperator" : operator,
                    "gender" : gender.length > 0 ? gender : null,
                    "name" : jsonRuleSelector.length > 0 ? jsonRuleSelector : null,
                    "age" : age == 0 ? null : age
                }})
            }
            if(name == 'HealthCheckStartDate'){
                return {...final, [name]: startDate}
            }
            if(name == 'HealthCheckEndDate'){
                return {...final, [name]: endDate}
            }
            console.log(res);
            return {...final, res}
            },{}
        )
        console.log(packageProp);
        payLoad.packageProp = [
            {
                [packId.packageId]: packageProp
            }
        ]

        _freedomAxios
        .post('corporate/insert', payLoad)
        .then((response) => {
            if(response.data.isSuccess){

            }
            alert();
        })
    }

    const PackagePropComponent = (packageId, entityRealtionId, index) => {
        return (
            <Modal
            open={pacakgePropertyClick}
            onClose={(e) => setPacakgePropertyClick(false)}
            sx={{
              position: 'absolute',
              left: '10%',
              overflow: 'scroll',
              height: '100%',
              display: 'block',
            }}
            style={{display:'flex',alignItems:'center',justifyContent:'center', minWidth: '200px', maxHeight:'800px'}}
            >
                <Card>   
                        {showProperties.map((val, index) => {
                            remainingProp = pacakgeProperty.filter((value,index) => val != value.PERP_PropertyName );
                            return (
                                <CardContent>
                                  <TextField sx = {{margin : '1%'}}
                                  disabled
                                  id="outlined-disabled"
                                  label = "Pacakge Property Name"
                                  defaultValue= {val}
                              />
                                <TextField sx = {{margin : '1%', width: '30%'}} 
                                   disabled
                                   id="outlined-disabled"
                                   label="Property Value"
                                   defaultValue= {remainingProp.PERP_PropertyValue}
                              />
                               {val == 'HealthCheckStartDate' ? <DatePickerComponent pos = {'start'} date = {'start'} /> : <></>}
                               {val == 'HealthCheckEndDate' ?  <DatePickerComponent pos = {'end'} date = {'end'} /> : <></>}
                               {val == 'JsonRule' ? <JsonRuleEditor /> : <></>}
                               
                              < Button sx = {{margin : '1%'}} onClick = {(e) => packageProperties(packageId, entityRealtionId)} >
                                 Edit
                              </Button>
                              </CardContent>
                            )
  

                        }) }

                        {pacakgeProperty.map((value, index) =>  { 
                            remainingProp = showProperties.filter((val,index) => val != value.PERP_PropertyName );
                            return (
                              <CardContent>
                                <TextField sx = {{margin : '1%'}}
                                disabled
                                id="outlined-disabled"
                                label = "Pacakge Property Name"
                                defaultValue= {value.PERP_PropertyName}
                            />
                              <TextField sx = {{margin : '1%', width: '30%'}} 
                                 disabled
                                 id="outlined-disabled"
                                 label="Property Value"
                                 defaultValue= {value.PERP_PropertyValue}
                            />
                             {value.PERP_PropertyName == 'HealthCheckStartDate' ? <DatePickerComponent pos = {'start'} date = {'start'} /> : <></>}
                             {value.PERP_PropertyName == 'HealthCheckEndDate' ?  <DatePickerComponent pos = {'end'} date = {'end'} /> : <></>}
                             {value.PERP_PropertyName == 'JsonRule' ? <JsonRuleEditor /> : <></>}
                             
                            < Button sx = {{margin : '1%'}} onClick = {(e) => packageProperties(packageId, entityRealtionId)} >
                               Edit
                            </Button>
                            </CardContent>
                        )})}
                        <CardContent>
                            {console.log(remainingProp)}
                            {remainingProp.map((val,index) => ( <div>
                                <TextField sx = {{margin : '1%', width: '30%' }} key = {index}
                                disabled
                                id="outlined-disabled"
                                label="Property Value"
                                defaultValue= {val} />
                                {val == 'HealthCheckStartDate' ? <DatePickerComponent pos = {'start'} date = {'start'} /> : <></>}
                                {val == 'HealthCheckEndDate' ?  <DatePickerComponent pos = {'end'} date = {'end'} /> : <></>}
                                {val == 'JsonRule' ? <JsonRuleEditor /> : <></>}
                             
                                </div> ))}
                        </CardContent>
                        <CardActions>
                        <Button sx = {{m : '3%', minWidth: '120px'}}
                        variant="contained"
                        onClick={() => packagePropertyCreation(packageId, showProperties)}
                        >CREATE</Button>
                        </CardActions>
                </Card>
            </Modal>
        )
    }

    const getErId = () => {
        let payLoad = {
            "entityId" : entityId,
            "contractType" : entityType
         }
         console.log(entityId, entityType);

         _freedomAxios.
         post('corporate/getERId', payLoad)
        .then((response) => {

                if(response.data.isSuccess){
                        let result = response.data.result;
                        if(result.length > 0){
                            setEntityRelationId(result[0].ER_Id);
                            pacakgeForERId(null,result[0].ER_Id);
                            return;
                        }
                        setErIdStatus(result.message);
                        return;
                }
                setErIdStatus(result.message);
                return ; 
         }) 
         .catch((error) => {

         });
    }

    const entityList = () =>{
        let list = [];
        const body = {
            lookUp: "EntityRelation"
        };
        _freedomAxios.post('corporate/lookup', body)
        .then(response => {
            if(response.data.isSuccess){
                
                list = JSON.parse(response.data.result);
                console.log("values ===>",list);
                setEntityRelationList(list)
            }
        }).catch(error => {
            
        })
    }

    const PackageCard = ({packageId, packageName, prefName,index}) => {
        return (  
         <Card 
         key = {index}
         sx = {{minWidth: '3vw', m : '1%', border:'2%'}}
       >
           <CardContent>
           <TextField sx = {{margin : '1%'}}
             disabled
             id="outlined-disabled"
             label = "PackageId"
             defaultValue= {packageId}
         />
           <TextField sx = {{margin : '1%', width: '30%'}} 
              disabled
              id="outlined-disabled"
              label="Package Name"
              defaultValue= {packageName}
         />
         < Button sx = {{margin : '1%'}} onClick = {(e) => packageProperties(packageId, entityRealtionId)} >
            Edit
         </Button>
         </CardContent>  
         <PackagePropComponent packageId = {packageId} entityRealtionId = {entityRealtionId} index = {packageId}/>
         </Card> 
         )
 }

    const packageProperties = (packageRelId) => {
        
        _freedomAxios
        .post('corporate/packageProperties' , {packageRelId : packageRelId})
        .then((response) => {
            if(response.data.isSuccess){
                 let res =  response.data.result;
                 setPacakgePropertyClick(true);
                 setPackageProperty(res);
            }
        })
        .catch((error) => {
            if(error.response && error.response.data.message){
                alert(error.response.data.message);
            }
            // setPackageProperty(res);
        })

    }

    useEffect(() => {
        entityList()
    }, []);
    


    return (
        <>
        <Modal
            open={entityRealtionId == 0}
            onClose={entityRealtionId != 0}
            style={{display:'flex',alignItems:'center',justifyContent:'center', minWidth: '200px', maxHeight:'800px'}}
            >
            <Box>
                <Card>
                    <CardContent>
                        <TextField sx = {{margin : '1%'}}
                            id="outlined-helperText"
                            label = "Entity Id"
                             type="number"
                             required
                             defaultValue={entityId}
                             onChange = {(e) => setEntityId(e.target.value)}
                        />
                         <Select sx={{ m: 1, minWidth: 120 }}
                         required = {true}
                        value={entityType}
                        onChange={(ev) => { setEntityType(ev.target.value) }}
                        renderValue={(selected) => selected}
                        label="Entity Type"
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        >
                            {
                        entityRelationList.map((val, idx) => (
                            <MenuItem sx={{ py: 0 }} value={val.Id} key={val.Id}>
                                <ListItemText primary={val.entity} />
                            </MenuItem>
                        ))
                        }
                        </Select>
                             <Button variant="contained" sx = {{m: 1}}
                                disabled={entityType == 0 || entityId == 0} 
                                onClick = {(e) => getErId() }
                             >
                                Get ER_ID
                            </Button> 
                            {erIdStatus ? <div>
                                {erIdStatus}  
                            </div> : <></>}
                </CardContent>
                </Card>
            </Box>
        </Modal>
        { packageForERId.map((val, index) => (<PackageCard packageId = {val.PER_Id} packageName = {val.PER_PackageAlias} index = {val.PER_Id} />))}
        </>
    )

}


